import React from 'react'
import styled from 'styled-components'

import { ContentBlock } from 'components/ContentBlock'

const Template = styled(props => <ContentBlock {...props} />)`
		width: 100%;
		div div {
				flex-direction:column;
		}
		div {
			display: flex!important;
			height: 100%;
			justify-content: center;
			align-items: center;
		}
`

export const StyledPage404 = styled(Template)`
	display: flex;
  justify-content: center;
  align-items: center;
	div {
		>div {
			margin-left: 55px;
		}
		h1 {
			font-size: 150px;
			font-weight: 500;
			color: #cdcdcd;
			margin: 0;
			line-height: 1;
		}
		h2 {
			font-size: 24px;
		}
  }
`

export const StyledNoItem = styled(Template)`
	height: 100%;
	div {
		flex-direction:column;
		p {
			font-size: 24px;
			font-weight: 400;
			margin-bottom: 26px;
		}
	}
`

export const StyledNoNetwork = styled(Template)`
	height: 100%;
	div {
		flex-direction:column;
		h2 {
			color: #cdcdcd;
			margin-top: 20px;
		}
  }
`

